import React from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from '../utils/FacebookPixel';

const services = [
  {
    title: 'Marketing Services',
    description: 'Innovative strategies to grow your brand and increase engagement.',
    href: '/marketing-services',
  },
  {
    title: 'IT Services',
    description: 'Cutting-edge solutions to enhance your digital infrastructure.',
    href: '/it-services',
  },
  {
    title: 'HR Services',
    description: 'Streamline your HR processes with our tailored services.',
    href: '/hr-services',
  },
  {
    title: 'Finance Services',
    description: 'Expert financial management to achieve your business goals.',
    href: '/finance-services',
  },
];

const Services = () => {
  return (
    <section className="py-16 bg-white relative">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-[#13689b]">
          Our Services
        </h2>
        <div className="grid gap-8 lg:grid-cols-4 md:grid-cols-2 grid-cols-1">
          {services.map((service, index) => (
            <div
              key={index}
              className="relative bg-white shadow-lg hover:shadow-xl rounded-lg p-8 transition-transform transform hover:scale-105 border-t-4 border-[#13689b] hover:border-blue-500 flex flex-col justify-between"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              {/* Decorative Blobs */}
              <div className="absolute -top-6 -left-6 w-16 h-16 bg-blue-100 opacity-50 rounded-full blur-2xl pointer-events-none"></div>
              <div className="absolute bottom-0 right-0 w-20 h-20 bg-blue-200 opacity-30 rounded-full blur-3xl pointer-events-none"></div>
              
              {/* Content */}
              <div>
                <h3 className="text-2xl font-semibold text-[#13689b] mb-4">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6">{service.description}</p>
              </div>

              {/* Button */}
              <div className="mt-auto">
                <Link
                  onClick={trackEvent("Explore Service")}
                  to={service.href}
                  className="inline-block text-white bg-[#13689b] px-4 py-2 rounded-md font-semibold transition-all hover:bg-white hover:text-[#13689b] hover:border hover:border-[#13689b]"
                >
                  Explore Service
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Background Decorative Blobs */}
      <div className="absolute top-[-100px] left-[-100px] w-[200px] h-[200px] bg-blue-300 opacity-30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-[-100px] right-[-100px] w-[250px] h-[250px] bg-blue-500 opacity-30 rounded-full blur-3xl"></div>
    </section>
  );
};


export default Services;
